import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Organization } from "~@/graphql/codegen/generated";

interface OrganizationState {
  selectedOrganization?: Organization;
}

const initialState: OrganizationState = {
  selectedOrganization: undefined,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setSelectedOrganization(
      state,
      action: PayloadAction<Organization | undefined>
    ) {
      state.selectedOrganization = action.payload;
    },
    clearSelectedOrganization(state) {
      state.selectedOrganization = undefined;
    },
  },
});

export const { setSelectedOrganization, clearSelectedOrganization } =
  organizationSlice.actions;
export default organizationSlice.reducer;
